import React, { useState } from 'react';
import { fromJS, Map } from 'immutable';
import { fetchNotifications } from '@kineticdata/react';
import { buffers } from 'redux-saga';
import { Link } from 'react-router-dom';
import {
  actionChannel,
  call,
  delay,
  fork,
  put,
  take,
  takeEvery,
} from 'redux-saga/effects';
import { connect } from 'react-redux';
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from 'reactstrap';
import { action, dispatch, regHandlers, regSaga } from '../../store';
import { Icon } from '@kineticdata/ui';

regSaga('NOTIFICATIONS', function* () {
  yield fork(function* () {
    try {
      const throttleChannel = yield actionChannel('*', buffers.none());
      while (true) {
        const triggerAction = yield take(throttleChannel);
        if (triggerAction?.type !== 'FETCH_NOTIFICATIONS') {
          yield put(action('FETCH_NOTIFICATIONS'));
        }
        yield delay(60000);
      }
    } finally {
    }
  });
  yield fork(function* () {
    try {
      while (true) {
        yield take('START_ENGINE');
        yield take('SET_WORKFLOW_ENGINE_STATUS');
        yield put(action('FETCH_NOTIFICATIONS'));
      }
    } finally {
    }
  });
});

regSaga(
  takeEvery('FETCH_NOTIFICATIONS', function* () {
    const result = yield call(fetchNotifications);

    if (result.error) {
      throw result.error;
    }

    const notifications = result.notifications.map(notifcation => ({
      key: notifcation.key ? notifcation.key : 'ResourceRestart',
      ...notifcation,
    }));

    yield put(action('FETCH_NOTIFICATIONS_SUCCESS', fromJS(notifications)));
  }),
);

regHandlers({
  FETCH_NOTIFICATIONS: state =>
    state.setIn(['app', 'notifications', 'loading'], true),
  FETCH_NOTIFICATIONS_SUCCESS: (state, { payload }) =>
    state
      .setIn(['app', 'notifications', 'data'], fromJS(payload))
      .setIn(['app', 'notifications', 'loading'], false),
});

const noticeTypes = Map({
  ResourceRestart: { type: 'warning', link: '/system/components' },
});

const iconsByType = {
  danger: 'alert-octagon',
  warning: 'alert-triangle',
  info: 'info',
};

export const reload = () => dispatch('FETCH_NOTIFICATIONS');

const NoticeRow = props => (
  <>
    <hr className="mx-3" />
    <div
      className={`border-0 ${
        props.type ? `border-start border-${props.type} border-4` : ''
      } py-2 px-3 d-flex align-items-center`}
    >
      {props.children}
    </div>
  </>
);

export const NoticesDropdown = connect(state => ({
  notifications: state.getIn(['app', 'notifications', 'data'], null),
  loading: !!state.getIn(['app', 'notifications', 'loading']),
}))(props => {
  const [open, setOpen] = useState(false);
  const toggle = () => {
    if (!open) reload();
    setOpen(o => !o);
  };

  return (
    props.notifications && (
      <Dropdown isOpen={open} toggle={toggle} nav>
        <DropdownToggle nav tag="button" title="Alerts">
          <Icon name="bell" />
          {props.notifications?.size > 0 && (
            <span className="badge badge-danger badge-sm">
              {!open || !props.loading ? (
                props.notifications.size
              ) : (
                <Icon name="loader" spin size={14} />
              )}
            </span>
          )}
        </DropdownToggle>
        <DropdownMenu end className="notices-menu">
          <div className="d-flex align-items-center py-2 px-3">
            <span className="fw-medium me-2">Alerts</span>
            {props.loading ? (
              <div className="skeleton-icon" />
            ) : (
              props.notifications?.size > 0 && (
                <span className="badge badge-danger badge-sm py-1">
                  {props.notifications?.size}
                </span>
              )
            )}
          </div>
          {props.loading ? (
            fromJS(new Array(props.notifications?.size || 1).fill(null)).map(
              (_, i) => (
                <NoticeRow key={`notice-skeleton-${i}`} type="light">
                  <div className="skeleton-icon flex-shrink-0" />
                  <div className="skeleton-text mx-2 w-100">
                    <span />
                    <span />
                  </div>
                  <div className="skeleton-button ms-auto" />
                </NoticeRow>
              ),
            )
          ) : props.notifications?.size > 0 ? (
            props.notifications?.map((notification, i) => {
              const { link, type } = noticeTypes.get(
                notification.get('key'),
                {},
              );
              return (
                <NoticeRow key={`notice-${i}`} type={type}>
                  <Icon name={iconsByType[type]} bg className="flex-shrink-0" />
                  <span className="mx-2">{notification.get('message')}</span>
                  {link && (
                    <DropdownItem tag="span" className="w-auto p-0 ms-auto">
                      <Link
                        className="btn btn-sm btn-outline-primary ms-auto"
                        to={
                          typeof link === 'function' ? link(notification) : link
                        }
                      >
                        Resolve
                      </Link>
                    </DropdownItem>
                  )}
                </NoticeRow>
              );
            })
          ) : (
            <NoticeRow>
              <div className="w-100 d-flex flex-column align-items-center text-muted">
                <Icon name="bell-off" xl bg />
                <div className="fw-bold mt-2">There are no alerts.</div>
              </div>
            </NoticeRow>
          )}
        </DropdownMenu>
      </Dropdown>
    )
  );
});
